import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { OwnersAndAdminsManager } from 'components/common/ownersAndAdmins';
import { PathCopy, PathDelete, PathIntegrations } from '.';

const PathManage = () => {
  const { dispatch } = useDispatch();

  const {
    pageState: { path }
  } = useReduxState();

  const updatePath = async () => {
    const paths = await api.get(`/admin/paths?id=${path.id}`);

    dispatch(
      actions.updatePageState({
        path: paths.data.paths[0]
      })
    );
  };

  return (
    <div className="manage">
      <div>
        <OwnersAndAdminsManager
          fallbackUrl="/paths"
          updateProduct={updatePath}
          url={`/admin/paths/${path.id}/owners`}
        />
      </div>

      <div style={{ marginTop: 40 }}>
        <PathIntegrations />
      </div>

      <div style={{ marginTop: 40 }}>
        <PathCopy />
      </div>

      <div style={{ marginTop: 40 }}>
        <PathDelete />
      </div>
    </div>
  );
};

export default PathManage;
